module.exports = __webpack_public_path__ + "img/station.d2cf4cd4.jpg";